<nav class="navbar navbar-expand-lg fixed-top bg-primary navbar-dark">
  <div class="container-fluid">
    <a routerLink="home" class="navbar-brand d-flex align-items-center gap-2">
      <img [src]="logoSrc" alt="Logo" width="150" />
    </a>

    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarContent"
      aria-controls="navbarContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0 d-flex justify-content-center w-100">
        @for (product of displayProducts; track product.name) {
          <li class="nav-item">
            <a
              class="nav-link"
              [ngClass]="{
                active: isProductActive(product.name),
                'product-active': isProductActive(product.name),
                'nav-link-disabled': product.disabled,
              }"
              [ngStyle]="{ 'border-bottom': isProductActive(product.name) ? '2px solid white' : 'none' }"
              [attr.aria-disabled]="product.disabled || null"
              (click)="selectProduct(product.name, product.disabled)">
              {{ product.name | translate | uppercase }}
            </a>
          </li>
        }
      </ul>

      <ul class="navbar-nav ms-auto mb-2 mb-lg-0 gap-3">
        <li class="nav-item d-flex align-items-center me-2">
          <a
            class="btn btn-outline-light d-flex align-items-center px-3 py-1"
            [href]="mailtoHref"
            rel="noopener"
            [attr.aria-label]="'HEADER.HELP' | translate"
            [attr.title]="supportEmail"
            data-qa="help-button">
            {{ 'HEADER.HELP' | translate }}
          </a>
        </li>
        <li class="nav-item dropdown d-flex align-items-center">
          <a
            class="nav-link dropdown-toggle text-dark bg-secondary d-flex align-items-center justify-content-between px-3"
            href="#"
            id="languageDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            style="width: 150px; padding-top: 4px; padding-bottom: 4px; border-radius: 4px">
            {{ selectedLang | uppercase }}
          </a>
          <ul class="dropdown-menu ng-secondary dropdown-menu-end text-dark w-75" aria-labelledby="languageDropdown">
            @for (lang of availableLanguages; track lang.code) {
              <li>
                <button class="dropdown-item" type="button" (click)="switchLanguage(lang.code)">
                  {{ lang.name }}
                </button>
              </li>
            }
          </ul>
        </li>
        <li class="nav-item d-lg-none">
          <a class="nav-link" (click)="toggleProfile()">
            <img class="profile-image" src="assets/img/default_profile.svg" alt="Profile" />
          </a>
          <ul class="dropdown-menu dropdown-menu-end w-75" [class.show]="isProfileMenuOpen">
            <li>
              <div class="dropdown-item">
                <img class="profile-image-icon me-2" src="assets/img/default_profile.svg" alt="Profile Icon" />
                <div class="profile-details">
                  <span>{{ username }}</span>
                  <span>{{ email }}</span>
                </div>
              </div>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <button class="dropdown-item" (click)="logout()">{{ 'USER.LOGOUT' | translate }}</button>
            </li>
          </ul>
        </li>
        <li class="nav-item dropdown d-none d-lg-block">
          <a
            class="nav-link dropdown-toggle m-0 p-0 d-flex align-items-center"
            href="#"
            id="profileDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false">
            <img class="profile-image" src="assets/img/default_profile.svg" alt="Profile" />
          </a>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="profileDropdown">
            <li>
              <div class="dropdown-item d-flex align-items-center">
                <img class="profile-image-icon me-2" src="assets/img/default_profile.svg" alt="Profile Icon" />
                <div class="profile-details">
                  <span>{{ username }}</span>
                  <span>{{ email }}</span>
                </div>
              </div>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <button class="dropdown-item" (click)="logout()">{{ 'USER.LOGOUT' | translate }}</button>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
